__turbopack_context__.v({
  "gallery-container": "StackedGallery-module-scss-module__f3M7nG__gallery-container",
  "load-more-button": "StackedGallery-module-scss-module__f3M7nG__load-more-button",
  "pdp-badge": "StackedGallery-module-scss-module__f3M7nG__pdp-badge",
  "pdp-badge-low-stock": "StackedGallery-module-scss-module__f3M7nG__pdp-badge-low-stock",
  "pdp-slider": "StackedGallery-module-scss-module__f3M7nG__pdp-slider",
  "pdp-wrapper": "StackedGallery-module-scss-module__f3M7nG__pdp-wrapper",
  "video-player": "StackedGallery-module-scss-module__f3M7nG__video-player",
});
